<template>
  <div class="total-loading justify-content-center align-items-center">
    <div>
      <div class="text-center">
        <h4>{{ text }}</h4>
      </div>
      <div
        class="w-100 mx-auto text-center"
        v-if="progressBar"
        style="max-width: 800px"
      >
        <div class="d-flex align-items-center mb-3 w-100 mt-3">
          <b-progress class="w-100" :max="maxLoadingTime" height="1rem">
            <b-progress-bar :value="loadingTime"></b-progress-bar>
          </b-progress>
        </div>
      </div>
      <div class="text-center mt-4" v-else>
        <img
          v-if="this.$store.state.application.id != 1"
          src="../assets/img/loading_default.svg"
          style="max-width: 120px"
        />
        <img
          v-else
          src="../assets/loading/Uli-loading-fd-fast.gif"
          style="max-width: 120px"
        />
        <!-- <div id="loading">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      loadingTime: 0,
      maxLoadingTime: 60,
    };
  },
  props: {
    text: {
      type: String,
      default: "Estamos em ação",
    },
    progressBar: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loading(newVal, oldValue) {
      if (newVal !== oldValue) {
        this.clearLoadingTimeInterval();

        if (newVal) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loadingTime++;
          }, 1000);
        }
      }
    },
    loadingTime(newVal, oldValue) {
      if (newVal !== oldValue) {
        if (newVal === this.maxLoadingTime) {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    this.startLoading();
  },
  methods: {
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval);
      this.$_loadingTimeInterval = null;
    },
    startLoading() {
      this.loading = true;
      this.loadingTime = 0;
    },
  },
};
</script>
<style scoped>
html,
body {
  height: 100%;
  width: 100%;
}
body {
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-loading {
  background-color: var(--bg-color);
  background-image: url("../assets/img/Uli-Fundo-Painel-desktop-load-branco.png");
  background-repeat: no-repeat;
  background-position: center bottom;

  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  color: #fff;
  z-index: 1051;
}
@media all and (max-width: 998px) {
  .total-loading {
    background-image: url("../assets/img/Uli-Fundo-Painel-mobile-load-branco.png");
    background-size: cover;
  }
}
.total-loading h4 {
  font-size: 24px;
  margin-bottom: 0;
}
#loading {
  height: 40px;
  position: absolute;
  left: calc(50% - 53px);
  top: calc(50% + 50px);
  text-align: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#loading span {
  width: 10px;
  height: 10px;
  margin: 2px;
  background: #fff;
  border-radius: 50%;
  display: inline-block;
  transition: all 400ms ease;
  animation: wave 2.5s ease infinite;
}

#loading span:nth-child(2) {
  animation-delay: 100ms;
}

#loading span:nth-child(3) {
  animation-delay: 200ms;
}

#loading span:nth-child(4) {
  animation-delay: 300ms;
}

#loading span:nth-child(5) {
  background: #fff;
  animation-delay: 400ms;
}
#loading span:nth-child(6) {
  background: #fff;
  animation-delay: 500ms;
}

@keyframes wave {
  0%,
  100% {
    transform: translate(0, 0);
  }
  40% {
    transform: translate(0, 20px);
    opacity: 0;
  }
  10% {
    transform: translate(0, -20px);
  }
}
.progress {
  border-radius: 2rem;
  background-color: rgb(0 0 0 / 20%);
}
.progress-bar {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue